module.exports = {
  "dof-simple-rich-text": {
    "whiteSpace": "nowrap",
    "textOverflow": "ellipsis",
    "overflow": "hidden",
    "paddingTop": "6",
    "paddingBottom": "6"
  },
  "textItem": {
    "display": "inline",
    "wordWrap": "break-word",
    "wordBreak": "break-all",
    "paddingTop": "4",
    "paddingBottom": "4"
  },
  "hasNumOrEn": {
    "paddingTop": "-2"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-7e3c0e08!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-simple-rich-text/index.vue
// module id = 520
// module chunks = 0 1